import React from 'react';
import AnimatedTitle from './animations/AnimatedTitle';
import CollisionAnimation from './animations/CollisionAnimation';

const Hero = () => {
  const videoRef = React.useRef(null);

  React.useEffect(() => {
    // Intenta reproducir el video cuando el componente se monte
    if (videoRef.current) {
      const playPromise = videoRef.current.play();

      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.log("Reproducción automática no permitida:", error);
          // No hacemos nada más, la imagen de fondo se mostrará
        });
      }
    }
  }, []);

  return (
    <section className="min-h-[800px] h-[90vh] relative overflow-hidden flex items-center justify-center">
      {/* Imagen de respaldo que se mostrará si el video no puede reproducirse */}
      <div
        className="absolute top-0 left-0 w-full h-full bg-cover bg-center z-0"
        style={{
          backgroundImage: "url('/images/background-fallback.jpg')"
        }}
      ></div>

      {/* Video de fondo */}
      <video
        ref={videoRef}
        autoPlay
        playsInline
        loop
        muted
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
      >
        <source
          src="https://static.vecteezy.com/system/resources/previews/001/797/998/mp4/bokeh-lake-4k-wedding-background-free-video.mp4"
          type="video/mp4"
        />
      </video>

      {/* Capa de superposición más suave */}
      <div className="absolute inset-0 bg-black bg-opacity-10 z-10"></div>

      {/* Contenido */}
      <div className="relative z-20 w-full h-full flex flex-col items-center justify-center">
        <div className="w-full max-w-4xl flex flex-col items-center">
          <div className="-translate-y-40 min-h-[380px] w-full relative">
            <CollisionAnimation />
          </div>
          <div className="-mt-40">
            <AnimatedTitle />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 